import React, { useEffect, useState } from 'react';
import { InputGroup, FormControl, Badge } from 'react-bootstrap';
import Button from '../Button';
import InfoBar from '../InfoBars';
import VerifyIndex from '../../../pages/UserManagement/CreateNewUser/VerificationCard/verifyIndex';
import VerifyIndexCard from '../../../pages/SelfRegistration/User/VerificationCard/verifyIndex';
import { RootState } from '../../../store/reducers';
import { useDispatch,useSelector } from 'react-redux';
import { resetForm, updateForm } from '../../../store/actions/userManagementAction';
interface Inputwithlabelprops {
  inputwithlabelPlaceholder: string;
  inputlabelPlaceholder: string;
  labelName?: string;
  inputlabeltype: string;
  inputlabelvalue?: any;
  disabled:boolean;
  verified:boolean;
  onChange: (value: string|boolean) => void;
  value?:any;
  errorMessage?:string;
  inputType?:string;
  onClickVerify:(value: boolean)=>void;
  verifyMessage?:string;
}
const InputHPRABHAVerify = ({
  inputwithlabelPlaceholder,
  inputlabelPlaceholder,
  labelName,
  inputlabeltype,
  inputlabelvalue,
  disabled,
  verified,
  onChange,
  errorMessage,
  inputType,
  onClickVerify,
  verifyMessage
}: Inputwithlabelprops) => {
  const inputlabelChange=(e: React.ChangeEvent<HTMLInputElement>) =>{
    e.target.value=e.target.value.split(' ').join('');
    if (!/^\d{0,14}$/.test(e.target.value)) {
      e.target.value = e.target.value.slice(0, -1);
    }
    onChange(e.target.value);
    setVerify(false);
    setInputEntered(e.target.value.trim() !== '')
  }
  const dispatch=useDispatch();
  const [verify,setVerify]=useState<boolean>(false);
  const [displayVerify,setDisplayVerify]=useState<boolean>(false);
  const [displayNotVerify,setDisplayNotVerify]=useState<boolean>(false);
  const [inputEntered, setInputEntered] = useState<boolean>(false);
  const isNotVerified=useSelector((state:RootState)=>state.user.isNotVerified);
  const [checkValid, setCheckValid] = useState<string>("");
  const [inputValue, setInputValue] = useState<string>('');
  const isVerified=useSelector((state:RootState)=>state.user.isVerified);
  //const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [verifyIndex,setVerifyIndex]=useState<any>('');
  const userType=useSelector((state:RootState)=>state.user.userType);
  const userDesignation = useSelector((state: RootState) => state.user.designation);
  const hfrAbhaId=useSelector((state:RootState)=>state.user.hfrAbha);
  const fName=useSelector((state:RootState)=>state.user.fName);
  const lName=useSelector((state:RootState)=>state.user.lName);
  const isSelfRegistration = useSelector((state: RootState) => state.registeration.isSelfRegister);
  let isDisabled=false;
  let isFacility=false;
  let isButtonDisable=false;
 // setInputValue(hfrAbhaId);
  if(userType==='Field Level User'){
    isDisabled=true ;
    if( fName && lName){
      isButtonDisable=true;

    }
    // if(inputlabelvalue){
    //   if(inputlabelvalue.length===14){
         //setInputValue(inputlabelvalue);
    //   }
    // }
    isFacility=true;


    // if(fName && lName){
    //   isButtonDisable=true;
    // }
  }
  if(userType==='Facility Level User' && userDesignation === 'MPW/MPHW'){
     isDisabled=true ;
    if( fName && lName){
      isButtonDisable=true;
    }
    isFacility=true;
  }
  else if(userType==='Facility Level User'){
    //isDisabled=hfrAbhaId.length === 14 ;
    if(hfrAbhaId && fName && lName){
      isButtonDisable=hfrAbhaId.length === 14 ;

    }
    isFacility=true;

  }
 
  useEffect(()=>{
    if(hfrAbhaId===''){
    setCheckValid('none');
  }
  },[hfrAbhaId])
  // if(  hfrAbhaId.length===14){
  //   setCheckValid(false);
  // }
  // else{
  //   
  // }
  const handleClick=()=>{
    //onChange(true)
    
    
    if(userType==='Field Level User' || (userType==='Facility Level User' && userDesignation === 'MPW/MPHW')){
      setVerifyIndex(true);      
    }
    else if(userType==='Facility Level User' && userDesignation !== 'MPW/MPHW'){
      setVerifyIndex(true); 
    }
    setVerify(true);
   onClickVerify(true)
  };
  const handleClose=()=>{
    setVerifyIndex(false); 
  }
  const handleVerify=(value:boolean,input:string)=>{
    value?setCheckValid("true"):setCheckValid("false"); 
    setInputValue(input);
    dispatch(updateForm("isVerified",`${value}`));
    if(value){
      dispatch(updateForm("hfrAbha",input));
      dispatch(updateForm("ishprEntered",true));
      dispatch(updateForm("isOkButtonClicked",true))
      dispatch(updateForm("isNotVerified",false));
    }
    else{
      dispatch(updateForm("isNotVerified",true));
    }
  }
  const getButtonColorType = (isVerified:any, inputlabelvalue:any, userType:any, isButtonDisable:any, userDesignation:any) => {
    if (isVerified === "true") {
      return "disabled";
    }
    if (inputlabelvalue?.length !== 14 && userType === "Facility Level User" && userDesignation !== 'MPW/MPHW') {
      return "disabled";
    }
    return isButtonDisable ? "primary" : "disabled";
  };
  const getIsButtonDisabled = (isVerified:any, inputlabelvalue:any, userType:any, isButtonDisable:any, userDesignation:any ) => {
    if (isVerified === "true") {
      return true;
    }
    if (inputlabelvalue?.length !== 14 && userType === "Facility Level User" && userDesignation !== 'MPW/MPHW') {
      return true;
    }
    return isButtonDisable ? false : true;
  };
  
  
  useEffect(()=>{
    //  if(verify)
    //  setVerify(verified);
    // if(verified===true){
    //   dispatch(updateForm("isVerified",`true`));
    // }
  if(verify===true && verified===true){
    setDisplayVerify(true);
    setDisplayNotVerify(false);

  }
  else if(verify===true && verified===false){
    setDisplayNotVerify(true);
    setDisplayVerify(false);
  }
  else{
    setDisplayNotVerify(false);
    setDisplayVerify(false);
  }})

  return (
    <div className="ip-with-label">
      {labelName && (
        <label className="label-name-required-for-ip">{labelName}</label>
      )}
      <div className="input-with-verify-button-main">
        <div className="input-with-button-verify">
          <InputGroup className="text-button-ip">
            <FormControl
              className="field-for-text-in-label"
              placeholder={inputwithlabelPlaceholder}
              onChange={inputlabelChange}
              type={inputlabeltype}
              value={inputlabelvalue }
              disabled={disabled}
            />
          </InputGroup>
         { checkValid==="true" && (
             <button className="verified-button-for-in-label" disabled={true}>
             {'Verified'}
           </button>)
          }
          { isVerified ==="true" && inputlabelvalue?.length===14 && (
             <button className="verified-button-for-in-label" disabled={true}>
             {'Verified'}
           </button>)
          }{
            isSelfRegistration ? <VerifyIndexCard handleVerify={handleVerify} handleClose={handleClose} showModal={verifyIndex}/>
            :<VerifyIndex handleVerify={handleVerify} handleClose={handleClose} showModal={verifyIndex}/>
          }
         { checkValid==="false" &&verified===false && inputlabelvalue?.length===14 &&isNotVerified &&(
             <button className="verified-button-for-in-label-not-verified" disabled={true}>
             {'Not Verified'}
           </button>)
          }
        </div>
        <div className={`verify-button-clickable-button ${verify}`}>
          <Button
            onClick={handleClick}
            disabled={getIsButtonDisabled(isVerified, inputlabelvalue, userType, isButtonDisable, userDesignation)}
            id=""
            buttonName={'Verify'}
            colorType={ getButtonColorType(isVerified, inputlabelvalue, userType, isButtonDisable, userDesignation)}
            icon={''}
            iconPosition={''}
          />
        </div>
      </div>
      <div className="input_field_infoBars">
        {inputType === 'success' ? (
          <InfoBar
            variant="success"
            message={errorMessage?errorMessage:'Success'}
            className="input_field_class"
          />
        ) : (
          ''
        )}
        {inputType === 'error' ? (
          <InfoBar
            variant="danger"
            message={errorMessage?errorMessage:''}
            className="input_field_class"
          />
        ) : (
          ''
        )}
      </div>
     
    </div>
  );
};
export default InputHPRABHAVerify;